import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import { BannerData } from "types/models/master/MasterApp";
import { useDispatch } from "react-redux";
import { deleteBanner, getBanners } from "redux/actions/Master";
import DeleteMessage from "./DeleteMessage";
import { isModuleAuthorized } from "@crema/utility/Utils";

interface OrderActionsProps {
  data: BannerData;
}

const OrderActions: React.FC<OrderActionsProps> = ({ data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);

  const handleEdit = () => {
    navigate(`/master/manageBanner/bannerUpdate/${data.id}`);
  };

  const handleDelete = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmDelete = () => {
    dispatch(deleteBanner(data) as any)
      .then(() => {
        dispatch(getBanners("", 1) as any);
      })
      .catch((error) => {
        console.error("Error deleting banner:", error);
      })
      .finally(() => {
        setOpenDialog(false);
      });
  };

  return (
    <Box>
      {isModuleAuthorized("Edit Banner") ? (
        <IconButton onClick={handleEdit}>
          <EditIcon style={{ fontSize: 24 }} />
        </IconButton>
      ) : (
        <Tooltip title="You don't have permission to edit">
          <span>
            <IconButton disabled>
              <EditIcon style={{ fontSize: 24 }} />
            </IconButton>
          </span>
        </Tooltip>
      )}

      {isModuleAuthorized("Delete Banner") ? (
        <IconButton onClick={handleDelete}>
          <DeleteIcon style={{ fontSize: 24 }} />
        </IconButton>
      ) : (
        <Tooltip title="You don't have permission to delete">
          <span>
            <IconButton disabled>
              <DeleteIcon style={{ fontSize: 24 }} />
            </IconButton>
          </span>
        </Tooltip>
      )}

      <DeleteMessage
        open={openDialog}
        onClose={handleCloseDialog}
        onConfirmDelete={handleConfirmDelete}
      />
    </Box>
  );
};

export default OrderActions;
